import React, {Component} from 'react';

import Workflow from "../core/Workflow";
import Dialog from "../util/Dialog.js";
import CroisiereDialog from "./CroisiereDialog";
import ProcessDialog from "./ProcessDialog";
import axios from "axios";
import AuthService from "../../AuthService";
import Moment from "moment";


class Croisiere extends Component {
    constructor(props) {
        super(props);

        this.wowkflow = React.createRef();

        this.state = {
            croisiereId: this.props.match.params.croisiereId,
            croisiereToCopy: {},
            workflowInitData: {
                WORKFLOW_ID: 1,
                PARAM_croisiereId: this.props.match.params.croisiereId,
                PARAM_croisiereTypeId: this.props.match.params.croisiereTypeId,
                PARAM_croisiereTypeDuree: this.props.match.params.croisiereTypeDuree,
                PARAM_croisiereBateauId: this.props.match.params.croisiereBateauId,
                PARAM_croisiereBateauName: this.props.match.params.croisiereBateauName,
                PARAM_croisiereCapitaineId: this.props.match.params.croisiereCapitaineId,
                PARAM_croisiereCapitaineName: this.props.match.params.croisiereCapitaineName,
                PARAM_croisiereDate: decodeURIComponent(this.props.match.params.croisiereDate),
            },
            calendarDialog: false,
            processDialog: false,
            sendAlert: false,
            alertSend: false,
            loaded: false
        }
        this.coreChange = this.coreChange.bind(this);
        this.coreSubmit = this.coreSubmit.bind(this);
        this.coreExternalCall = this.coreExternalCall.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
    }
    async componentDidMount() {
        if (!!this.props.match.params.selectedCroisireToCopyId && this.props.match.params.selectedCroisireToCopyId!=-1) {
            await this.loadCroisiereCopy();
        } else {
            this.setState({
                loaded: true
            });
        }
    }

    async componentWillUpdate() {
        if (!!this.props.match.params.selectedCroisireToCopyId  && this.props.match.params.selectedCroisireToCopyId!=-1) {
            await this.updateFields();
        }
    }

    async updateFields() {
        if (!!this.props.match.params.selectedCroisireToCopyId  && this.props.match.params.selectedCroisireToCopyId!=-1) {
            //radio
            await this.updateRadioCoreInput('BLOCK_ITEM_100053');
            await this.updateRadioCoreInput('BLOCK_ITEM_100116');
            await this.updateRadioCoreInput('BLOCK_ITEM_100059');

            await this.updateCoreInput('BLOCK_ITEM_100052', 1);
            await this.updateCoreInput('BLOCK_ITEM_100060', 1);
            await this.updateCoreInput('BLOCK_ITEM_100061', 1);
            await this.updateCoreInput('BLOCK_ITEM_100101', 1);
            await this.updateCoreInput('BLOCK_ITEM_100102', 1);
            await this.updateCoreInput('BLOCK_ITEM_100105', 1);
            await this.updateCoreInput('BLOCK_ITEM_100104', 1);
            await this.updateCoreInput('BLOCK_ITEM_100111', 1);
            await this.updateCoreInput('BLOCK_ITEM_100115', 1);
            await this.updateCoreInput('BLOCK_ITEM_100113', 1);
            await this.updateCoreInput('BLOCK_ITEM_100114', 1);

            //textarea
            await this.updateCoreInput('BLOCK_ITEM_100055', 2);

            //select
            await this.updateCoreInput('BLOCK_ITEM_100106', 3);
            await this.updateCoreInput('BLOCK_ITEM_100054', 3);
            await this.updateCoreInput('BLOCK_ITEM_100112', 3);
            await this.updateCoreInput('BLOCK_ITEM_100051', 3);

            if (!this.state.loaded) {
                await this.setState({
                    loaded: true
                });
            }
        }
    }

    delay(time) {
        return new Promise(resolve => setTimeout(resolve, time));
    }

    async updateRadioCoreInput(inputClassName) {
        var value = true;
        switch (inputClassName) {
            case  'BLOCK_ITEM_100053':
                value = this.state.croisiereToCopy.touriste
                break;
            case  'BLOCK_ITEM_100116': //radio inverse attention ne pas changer
                value = !this.state.croisiereToCopy.isPasDeSoldeARecuperer
                break;
            case  'BLOCK_ITEM_100059': //on force le creer par admin a true
                value = true
                break;
        }
        this.delay(10).then(() => this.updateRadio(inputClassName, value));
    }

    updateRadio (inputClassName, value, reverse) {
        var element = document.querySelector("input[name="+inputClassName+"][value="+value+"]");
        element.click();
    }

    async updateCoreInput(inputClassName, type) {

        let classString ;
        if (type==1) {
            classString = '.' + inputClassName + ' input'
        } else if (type==2) {
            classString = 'textarea[name=' + inputClassName + ']'
        } else if (type == 3) {
            classString = 'select[name=' + inputClassName + ']'
        }

        if (document.querySelector(classString) !== null) {
            switch (inputClassName) {
                case 'BLOCK_ITEM_100052':
                    this.setNativeValue(document.querySelector(classString), this.state.croisiereToCopy.nombrePassager, type);
                    break;
                case 'BLOCK_ITEM_100060':
                    this.setNativeValue(document.querySelector(classString), this.state.croisiereToCopy.delaiBefore, type);
                    break;
                case 'BLOCK_ITEM_100061':
                    this.setNativeValue(document.querySelector(classString), this.state.croisiereToCopy.delaiAfter, type);
                    break;
                case 'BLOCK_ITEM_100101':
                    this.setNativeValue(document.querySelector(classString), this.state.croisiereToCopy.clientPrenom, type);
                    break;
                case 'BLOCK_ITEM_100102':
                    this.setNativeValue(document.querySelector(classString), this.state.croisiereToCopy.clientNom, type);
                    break;
                case 'BLOCK_ITEM_100105':
                    this.setNativeValue(document.querySelector(classString), this.state.croisiereToCopy.clientEmail, type);
                    break;
                case 'BLOCK_ITEM_100054':
                    this.setNativeValue(document.querySelector(classString), this.state.croisiereToCopy.croisiereRamassage.id, type);
                    break;
                case 'BLOCK_ITEM_100055':
                    this.setNativeValue(document.querySelector(classString), this.state.croisiereToCopy.ramassageSpecific, type);
                    break;
                case 'BLOCK_ITEM_100104':
                    this.setNativeValue(document.querySelector(classString), this.state.croisiereToCopy.clientTel, type);
                    break;
                case 'BLOCK_ITEM_100106':
                    this.setNativeValue(document.querySelector(classString), this.state.croisiereToCopy.clientRefPays, type);
                    break;
                case 'BLOCK_ITEM_100111':
                    this.setNativeValue(document.querySelector(classString), this.state.croisiereToCopy.factureNom, type);
                    break;
                case 'BLOCK_ITEM_100115':
                    this.setNativeValue(document.querySelector(classString), this.state.croisiereToCopy.factureAdresse, type);
                    break;
                case 'BLOCK_ITEM_100113':
                    this.setNativeValue(document.querySelector(classString), this.state.croisiereToCopy.factureCodePostal, type);
                    break;
                case 'BLOCK_ITEM_100114':
                    this.setNativeValue(document.querySelector(classString), this.state.croisiereToCopy.factureVille, type);
                    break;
                case 'BLOCK_ITEM_100112':
                    this.setNativeValue(document.querySelector(classString), this.state.croisiereToCopy.factureRefPays, type);
                    break;
                case 'BLOCK_ITEM_100051':
                    this.setNativeValue(document.querySelector(classString), this.state.croisiereToCopy.croisiereEvent.id, type);
                    break;
            }
        }
    }

    setNativeValue(element, value, type) {
        if (type==1 || type==2) {
            const valueSetter = Object.getOwnPropertyDescriptor(element, 'value').set
            const prototype = Object.getPrototypeOf(element)
            const prototypeValueSetter = Object.getOwnPropertyDescriptor(prototype, 'value').set
            if (valueSetter && valueSetter !== prototypeValueSetter) {
                prototypeValueSetter.call(element, value)
            } else {
                valueSetter.call(element, value)
            }
            let ev2 = new Event('input', {bubbles: true});
            element.dispatchEvent(ev2);
        }

        if (type==3) {
            var nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLSelectElement.prototype, "value").set;
            nativeInputValueSetter.call(element, value);
            var ev2 = new Event('change', { bubbles: true});
            element.dispatchEvent(ev2);
        }

    }

    async loadCroisiereCopy() {
        /*Copy croisiere*/
        await axios.post(AuthService.getUrl("/getCroisiere"), {
            croisiereId: this.props.match.params.selectedCroisireToCopyId
        }, AuthService.getAuthHeader()).then(async res => {
            await this.setState({
                croisiereToCopy: res.data.data.croisiere
            });
        });
    }

    async coreChange(e) {
        if (e.target.name === "BLOCK_ITEM_100001" && !(this.state.croisiereId) && !!(e.target.value)) {
            document.location = "/admin/croisiere/" + e.target.value;
        }
        if (e.target.name === "BLOCK_ITEM_100003") {
            this.setState({croisiereDate: e.target.value});
        }
        if (e.target.name === "BLOCK_ITEM_100004") {
            this.setState({croisiereBateauId: e.target.value});
        }
        if (e.target.name === "BLOCK_ITEM_100005") {
            this.setState({croisiereCapitaineId: e.target.value});
        }
    }

    async coreExternalCall(method) {
        if (method === "calendarDialog") {
            await axios.post(AuthService.getUrl("/getCroisiere"), {
                croisiereId: this.state.croisiereId,
                villeId: this.state.villeId
            }, AuthService.getAuthHeader()).then(res => {
                this.props.history.push('/admin/calendriers/' + res.data.data.croisiere.croisiereType.ville.id + '/' + this.state.croisiereId + '/' + Moment(res.data.data.croisiere.date, "DD/MM/YYYY HH:mm").format("DDMMYYYY").toString());
            });
            //this.setState({calendarDialog: true});
        }
        if (method === "processDialog") {
            this.setState({processDialog: true});
        }
        if (method === "leave") {
            this.props.history.push('/admin/reservations');
        }
        if (method === "sendAlert") {
            this.setState({sendAlert: true});
            await axios.post(AuthService.getUrl('/sendAlert'), {
                croisiere: {
                    id: this.state.croisiereId
                }
            }, AuthService.getAuthHeader()).then(res => {
                this.setState({alertSent: true});
            });
        }
    }

    async coreSubmit(data) {
        if (!!data) {
            data.screen.blocks[0].blockItems.map(blockItem => {
                if (blockItem.id === 100001) {
                    this.setState({croisiereId: blockItem.values[0]});
                    //TODO ce con est vide a la création mais comme réact est con il reload tout seul a cause du this.state du coup ca marche
                }
                if (blockItem.id === 100013) {
                    let realValue = blockItem.values[0];
                    let count = realValue.split("|")[0];
                    let element = document.querySelector('#nbOptions');
                    if (element!=null) {
                        let nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
                        nativeInputValueSetter.call(element, count);
                        let ev2 = new Event('input', {bubbles: true});
                        element.dispatchEvent(ev2);
                    }
                }
            });
        }
    }

    async closeDialog(e, validMessage, errorMessage) {
        document.location = "/admin/croisiere/" + this.state.croisiereId;
        /*this.wowkflow.current.loadData(false);
        this.setState({calendarDialog: false});
        this.setState({processDialog: false});

        this.setState({validMessage: validMessage});
        this.setState({errorMessage: errorMessage});*/
    }

    render() {
        return (
            <div className="responsiveForm">
                {!!(this.state.errorMessage) &&
                <div className="errorMessage">
                    <span>{this.state.errorMessage}</span>
                </div>
                }
                {!!(this.state.validMessage) &&
                <div className="actionMessage">
                    <span>{this.state.validMessage}</span>
                </div>
                }
                {!!(this.state.alertSent) &&
                <div className="actionMessage">
                    <span>Notification envoyée</span>
                </div>
                }
                {this.state.loaded &&
                <React.Fragment>
                    <Workflow ref={this.wowkflow}
                              initData={this.state.workflowInitData}
                              onChange={this.coreChange}
                              onSubmit={this.coreSubmit}
                              externalCall={this.coreExternalCall}
                              primaryKey={this.state.croisiereId}/>

                    {this.state.calendarDialog &&
                    <Dialog close={this.closeDialog}>
                        <CroisiereDialog
                            toggleCalendar={this.toggleCalendar}
                            croisiereId={this.state.croisiereId}
                            croisiereDate={this.state.croisiereDate}
                            croisiereBateauId={this.state.croisiereBateauId}
                            croisiereCapitaineId={this.state.croisiereCapitaineId}/>
                    </Dialog>
                    }
                    {this.state.processDialog &&
                    <Dialog close={this.closeDialog}>
                        <ProcessDialog
                            closeDialog={this.closeDialog}
                            croisiereId={this.state.croisiereId}/>
                    </Dialog>
                    }
                </React.Fragment>
                }
            </div>
        );
    }
}

export default Croisiere;
